var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 591 314-314q21-21 51.5-21t51.5 21q22 22 22 52t-22 52L564 747q-21 21-51.5 21T461 747L95 381q-22-22-22-52t22-52q21-21 51.5-21t51.5 21l314 314z"
  })));
};
export { SvgChevronDown as ReactComponent };
export default __webpack_public_path__ + "93beb0542f89e9e250768eef981d13f8.svg";